export default "__VITE_ASSET__BfmhAt$6__"